import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('media-query', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('media-query');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
